
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Controlador as Bus } from './preguntas-controlador';

    import moment from 'moment';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    import { Empresa, Cuenta } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
    import item from './preguntas-lista-item.vue';
    import filtros from './preguntas-opciones.vue';
    import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            item,
            filtros
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }
        public get Buscador() { return Bus.Buscador; }


        public Estado: string = 'cargando';
        public CargandoMas: boolean = false;
        public Filtrando: boolean = false;

        public Items: Pregunta[] = [];

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            this.Eventos.push( this.Buscador.onActualizar.subscribe( () =>
            {
                this.Items = this.Buscador.Items;
                this.Estado = this.Buscador.Estado;
                this.Refrescar();
            } ) );

            this.Eventos.push( this.Buscador.onNuevaPregunta.subscribe( ( x ) =>
            {
                if ( x.Cuenta == this.Buscador.Filtros.Cuentas[this.Buscador.Filtros.Valores.Cuenta].Id || !this.Buscador.Filtros.Cuentas[this.Buscador.Filtros.Valores.Cuenta].Id )
                {
                    if ( this.Items.findIndex( a => a.Id == x.Id ) == -1 )
                        this.Items.unshift( x );
                }
                else
                    Utiles.Notificaciones.Info( 'Hay una nueva pregunta en ' + x.Cuenta );
                this.Estado = 'ok';

            } ) );
            this.Buscador.Iniciar();
            this.Buscar();
        }

        async Buscar()
        {
            await this.Buscador.Buscar( this.Pagina );
        }


        protected Pagina = 1;
        async CargarMas()
        {
            this.CargandoMas = true;
            this.Pagina += 1;
            await this.Buscador.Buscar( this.Pagina );
            this.Items.push( ...this.Buscador.Items );
            this.CargandoMas = false;
        }

        CambiarCuenta( x: number )
        {
            this.Buscador.Filtros.Valores.Cuenta = x;
            this.Buscar();
        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => { this.Refresh = true; } );
        }
    }
